import React from 'react';
import './Display.css'

export default ({ value }) => {
  return (
    <div className='display'>{ value }</div>
  )
}